import { render, staticRenderFns } from "./StatsIndex.vue?vue&type=template&id=7472486c"
import script from "./StatsIndex.vue?vue&type=script&lang=js"
export * from "./StatsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports